import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var SectionBridge = function SectionBridge(_ref) {
  var children = _ref.children,
      backgroundTop = _ref.backgroundTop,
      backgroundBottom = _ref.backgroundBottom;
  var getClassName = getClassNameFactory(SectionBridge.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames("".concat(backgroundTop, "Top"), "".concat(backgroundBottom, "Bottom"))
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

SectionBridge.backgrounds = ["grayLighter", "grayLightest", "white"];
SectionBridge.defaultProps = {
  backgroundBottom: "grayLightest",
  backgroundTop: "white"
};
SectionBridge.displayName = "SectionBridge";
SectionBridge.propTypes = {
  /**
   * Markup elements to render in SectionBridge
   */
  children: PropTypes.node,

  /**
   * Set background color for top half of SectionBridge
   */
  backgroundTop: PropTypes.oneOf(SectionBridge.backgrounds),

  /**
   * Set background color for bottom half of SectionBridge
   */
  backgroundBottom: PropTypes.oneOf(SectionBridge.backgrounds)
};
export default SectionBridge;